import helpers from "@/services/helpers";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      initialForm: null,
      form: null,
      hasChanges: false,
      loading: false
    };
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.hasChanges = !helpers.compareObjects(this.form, this.initialForm);
        this.updateTitle();
      }
    }
  },
  computed: {
    classList() {
      return {
        "is-loading": this.loading,
        "has-changes": this.hasChanges
      };
    }
  },
  methods: {
    ...mapActions({
      openModal: "modal/open"
    }),
    updateTitle() {
      const title = document.title;
      const label = this.$l10n("CHANGED_LABEL");

      if (this.hasChanges) {
        if (!title.includes(label)) {
          document.title = `${label} ${title}`;
          window.onbeforeunload = () => false;
        }
      } else {
        if (title.includes(label)) {
          window.onbeforeunload = null;
          document.title = title.substring(label.length);
        }
      }
    },
    cancel() {
      this.$router.back();
    },
    restore() {
      // this method need implement in inherited component
    },
    // Used in parent component
    async canLeavePage() {
      let accessed = true;

      if (this.hasChanges) {
        const { confirm = false } = await this.openModal({
          name: "confirm",
          data: {
            title: this.$l10n("CONTINUE"),
            caption: this.$l10n("HAVE_UNSAVE_CHANGES")
          }
        });

        accessed = confirm;

        if (accessed) {
          await this.restore();
        } else {
          this.updateTitle();
        }
      }

      return accessed;
    }
  }
};
